import React from "react";
import styled from "styled-components";
import { theme } from "../../styles/theme";

const SectionContainer = styled.section`
  background-image: url("/assets/images/skybackground.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: ${theme.spacing.xxxl} ${theme.spacing.xl};
  margin-top: -45px;
  margin-bottom: -6px;
  min-height: 100vh;
  padding-top: 80px;

  @media (max-width: ${theme.breakpoints.desktop}) {
    margin-top: -90px;
    padding-top: 120px;

  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: ${theme.spacing.xxl} ${theme.spacing.lg};
    padding-top: 80px;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 30px;
`;

// 詐欺事例セクション
const FraudExamplesSection = styled.div`
  position: relative;
  background: white;
  padding: ${theme.spacing.xl};
  padding-top: 80px;
  margin-bottom: ${theme.spacing.xxl};
  margin-top: 60px;
  border-radius: 20px;
  box-shadow: 12px 12px 0 0 #cce880,
    /* 右下の黄緑系ずらし枠 */ 16px 16px 24px 0 rgba(0, 0, 0, 0.18); /* 黄緑影のさらに外側に黒い影 */

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.lg};
    padding-top: 60px;
  }
`;

const FraudSectionTitle = styled.img`
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 550px;
  height: auto;

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 400px;
    top: -25px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 250px;
    top: -15px;
  }
`;

const Footnote = styled.p`
  font-size: 0.7rem;
  color: #636e72;
  text-align: left;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const FraudContent = styled.div`
  padding: 0 80px;
  background: white;

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: 15px;
    margin-top: -60px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 10px;
  }
`;

const FraudTextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 35px;
  margin-top: 80px;

  @media (max-width: ${theme.breakpoints.tablet}) {
    margin-top: 50px;
  }
`;

const FraudItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding-bottom: 50px;

  @media (max-width: ${theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: center;
    padding-bottom: 30px;
    gap: 20px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    gap: 15px;
  }
`;

const FraudImage = styled.img`
  width: 300px;
  height: auto;
  flex-shrink: 0;

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 260px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 200px;
  }
`;

const FraudBannerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
  padding-bottom: 30px;
`;

const FraudText = styled.div`
  flex: 1;
  font-size: 1.25rem;
  line-height: 1.7;
  color: ${theme.colors.text.primary};
  font-weight: 500;
  letter-spacing: 1.5px;

  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 15px;
    color: ${theme.colors.text.primary};

    .english-text {
      font-family: "FOT-UD丸ゴ_ラージ Pr6N", sans-serif;
    }
    .japanese-text {
      font-family: "TA丸ゴGF03", sans-serif;
    }
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    letter-spacing: 0.8px;
    font-size: 1.1rem;
    line-height: 1.5;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    letter-spacing: 0.8px;
    font-size: 1rem;
    line-height: 2.5;
  }
`;

const Banner = styled.img`
  width: 50%;
  height: auto;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 60%;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 80%;
  }
`;

// 詐欺バスター紹介セクション
const FraudBusterSection = styled.div`
  position: relative;
  background: white;
  padding: ${theme.spacing.xl};
  padding-top: 80px;
  margin-top: 100px;
  border-radius: 20px;
  box-shadow: 12px 12px 0 0 #c94b4b,
    /* 右下の赤系ずらし枠 */ 16px 16px 24px 0 rgba(0, 0, 0, 0.18); /* 赤影のさらに外側に黒い影 */

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.lg};
    padding-top: 60px;
    margin-top: 60px;
  }
`;

const BusterSectionTitle = styled.img`
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 550px;
  height: auto;

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 400px;
    top: -25px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 250px;
    top: -15px;
  }
`;

const BusterContent = styled.div`
  padding: 20px;
  background: white;

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: 15px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 10px;
  }
`;

const BusterDescription = styled.p`
  text-align: left;
  font-size: 1.25rem;
  line-height: 1.7;
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.md};
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  letter-spacing: 1.5px;

  @media (max-width: ${theme.breakpoints.tablet}) {
    font-size: 1.1rem;
    line-height: 1.5;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1rem;
    letter-spacing: 0.8px;
    line-height: 2.5;
  }
`;

const BusterImage = styled.img`
  max-width: 60%;
  height: auto;
  margin-bottom: ${theme.spacing.xl};
  display: block;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${theme.breakpoints.tablet}) {
    max-width: 90%;
  }
`;

const DetailButtonWrapper = styled.div`
  text-align: center;
  margin-top: 80px;
  display: flex;
  justify-content: center;

  @media (max-width: ${theme.breakpoints.tablet}) {
    margin-top: 60px;
  }
`;

const StoreButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${theme.spacing.lg};

  @media (max-width: ${theme.breakpoints.mobile}) {
    gap: ${theme.spacing.md};
  }
`;

const StoreButton = styled.a`
  display: inline-block;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    filter: brightness(1.1);
  }

  img {
    height: 80px;
    width: auto;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    img {
      height: 60px;
      width: auto;
    }
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    img {
      height: 40px;
      width: auto;
    }
  }
`;

const InfoBoxWrapper = styled.div`
  position: relative;
  background: white;
  padding: ${theme.spacing.xl} 110px;
  padding-top: 40px;
  margin-top: 100px;
  border-radius: 20px;
  box-shadow: 12px 12px 0 0 #fac301,
    /* 右下のオレンジ系ずらし枠 */ 16px 16px 24px 0 rgba(0, 0, 0, 0.18); /* オレンジ影のさらに外側に黒い影 */

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: ${theme.spacing.lg} ${theme.spacing.xxl};
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.lg} ${theme.spacing.xl};
    margin-top: 60px;
  }
`;

const InfoBoxSectionTitle = styled.img`
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 550px;
  height: auto;

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 400px;
    top: -25px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 250px;
    top: -15px;
  }
`;

const InfoBoxContent = styled.div`
  padding: 10px 20px 10px 20px;
  background: white;

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: 15px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 10px;
  }
`;

const InfoText = styled.p`
  font-size: 1.25rem;
  line-height: 1.7;
  color: ${theme.colors.text.primary};
  text-align: left;
  margin-top: 0;
  margin-bottom: 0;

  @media (max-width: ${theme.breakpoints.tablet}) {
    font-size: 1.1rem;
    line-height: 1.5;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    letter-spacing: 0.8px;
    font-size: 1rem;
    line-height: 2.5;
  }
`;

const FraudBusterSectionComponent: React.FC = () => {
  return (
    <SectionContainer id="fraud-buster">
      <Container>
        {/* 詐欺事例セクション */}
        <FraudExamplesSection>
          <FraudSectionTitle
            src="/assets/images/sagijirei_aset.png"
            alt="詐欺事例"
            loading="lazy"
          />
          <FraudContent>
            <FraudTextArea>
              <FraudItem>
                <FraudImage
                  src="/assets/images/sns_sagijirei.png"
                  alt="詐欺対策アプリ1"
                  loading="lazy"
                />
                <FraudText>
                  <h3>
                    <span className="english-text">SNS</span>
                    <span className="japanese-text">型投資詐欺とは</span>
                  </h3>
                  <p>
                    SNS型投資詐欺とは、SNS（ソーシャルネットワーキングサービス）のインターネット広告やダイレクトメッセージを通じて知り合った相手に、非対面で架空の投資を勧め、投資金や手数料の名目で金銭をだまし取る詐欺の手口です。
                    <br />
                    犯人はSNS上で著名人や投資家を装って「必ずもうかる」といった甘い言葉で接触し、その後、チャットアプリのグループへ誘導します。そしてグループチャットの中で、複数の"サクラ"による演出、偽の運用利益を見せる、少額の実利益を引き出させるなど、多様な手段を用い、長い時間をかけて被害者の信用を得ていきます。その結果、何度も投資し資産の大部分を失うなど、被害が長期化・高額化するケースも確認されていますので、注意が必要です。
                  </p>
                </FraudText>
              </FraudItem>

              <FraudItem>
                <FraudImage
                  src="/assets/images/sms_sagijirei.png"
                  alt="詐欺対策アプリ2"
                  loading="lazy"
                />
                <FraudText>
                  <h3>
                    <span className="english-text">SMS</span>
                    <span className="japanese-text">フィッシング詐欺とは</span>
                  </h3>
                  <p>
                    SMSフィッシング詐欺とは、スマートフォンのショートメッセージ（SMS）を悪用して認証情報や個人情報を盗む詐欺の手口です。実在する企業やサービス（例：宅配業者、金融機関、官公庁、オンラインショッピングサイト、決済サービスなど）を装い、ショートメッセージに含まれるリンクから偽サイトへ誘導します。この偽サイト上で、ログインID・パスワード、クレジットカード番号、個人情報などの入力を要求し、それらの情報を盗み取ることが目的です。
                    <br />
                    SMSフィッシング詐欺の被害は、個人情報を盗み取られることだけでは終わりません。盗まれた情報を用いたクレジットカードの不正利用や、銀行口座からの預金の不正送金、各種サービスへの不正ログイン・アカウント乗っ取り、なりすまし被害などに繋がるため、注意が必要です。
                  </p>
                </FraudText>
              </FraudItem>
            </FraudTextArea>

            <FraudBannerContainer>
              <Banner
                src="/assets/images/banner_bosagi_game.jpg"
                alt="バナー1"
                loading="lazy"
                onClick={() =>
                  window.open(
                    "https://news.trendmicro.com/ja-jp/",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              />
            </FraudBannerContainer>
          </FraudContent>
        </FraudExamplesSection>

        <InfoBoxWrapper>
          <InfoBoxSectionTitle
            src="/assets/images/bosagi_aset.png"
            alt="防サギ訓練開発ストーリー"
            loading="lazy"
          />
          <InfoBoxContent>
            <InfoText>
              『防サギ訓練』は、深刻化する詐欺被害を未然に防ぐことを目的に、消費者の詐欺対策リテラシー向上をめざして設計されたオンラインゲームです。詐欺対策のリーディングカンパニーであるトレンドマイクロと、ゲーミフィケーションの専門企業セガエックスディーが共同開発しました。
              <br />
              <br />
              本ゲームは、キャラクターが遭遇する詐欺ストーリーを疑似体験しながら、クイズ形式で楽しく詐欺対策を学べる構成になっています。「自分は大丈夫」「詐欺は不注意な人が引っかかるもの」と考えている人でも、プレイを重ねるうちに詐欺の手口や対策への理解を深め、自然と防サギ力を身につけられることを目指しています。{" "}
              <br />
              また、本作は、本作は詐欺の心理的メカニズムに精通した<b>立正大学 心理学部 対人・社会心理学科 西田公昭教授</b>が監修を担当。専門的知見に基づいたストーリーやクイズを通して得られる気づきは、知識にとどまらず、実生活で役立つ実践的な理解へとつながります。
            </InfoText>
          </InfoBoxContent>
        </InfoBoxWrapper>

        {/* 詐欺バスター紹介セクション */}
        <FraudBusterSection>
          <BusterSectionTitle
            src="/assets/images/sagijirei_aset2.png"
            alt="詐欺バスター"
            loading="lazy"
          />
          <BusterContent>
            <BusterImage
              src="/assets/images/sagibaster_content.png"
              alt="詐欺事例1"
              loading="lazy"
            />
            <BusterDescription>
              トレンドマイクロ 詐欺バスターは、詐欺電話やネット詐欺を早期に検知し・ブロックする防犯アプリです。従来からある特殊詐欺やフィッシング詐欺に加え、ディープフェイクなどAIを悪用した最新の詐欺まで対応。詐欺防止に特化した機能で、巧妙化する詐欺の脅威からあなた（とあなたの家族※）を守ります。
            </BusterDescription>

            <Footnote>
              ※登録された、同居のご家族もしくは同居していない親と子
            </Footnote>

            <DetailButtonWrapper>
              <StoreButtonContainer>
                <StoreButton
                  href="https://api.link.trendmicro.com/events/landing-page?product_id=4cc29&source=game_lp&locale=ja-jp&platform=ios&utm_content=scamcheck"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="App Storeからダウンロード"
                >
                  <img src="/assets/images/Apple.png" alt="App Store" loading="lazy" />
                </StoreButton>

                <StoreButton
                  href="https://api.link.trendmicro.com/events/landing-page?product_id=4cc29&source=game_lp&locale=ja-jp&platform=android&utm_content=scamcheck"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Google Playから入手"
                >
                  <img src="/assets/images/google.png" alt="Google Play" loading="lazy" />
                </StoreButton>
              </StoreButtonContainer>
            </DetailButtonWrapper>
          </BusterContent>
        </FraudBusterSection>
      </Container>
    </SectionContainer>
  );
};

export default FraudBusterSectionComponent;